import { CompanyOverviewProps } from "@/queries/aboutUsQuery";
import Block from "./block";
import Link from "next/link";

export function CompanyOverview({
  companyOverview,
}: {
  companyOverview: CompanyOverviewProps;
}) {
  const { overline, title, subTitle, ctas } = companyOverview;

  return (
    <Block className="border-b-4 border-platinum lg:pb-20">
      <div className="families-colorway text-center">
        <span className="text-overline-2">{overline}</span>
      </div>
      <h3 className="text-deco-head-2 mt-3 text-center font-rebrand md:text-heading-45">
        {title}
      </h3>

      <div className="text-body-1 mx-auto mt-8 text-center lg:max-w-[900px]">
        {subTitle}
      </div>

      <div className="text-body-1 m-auto mt-10 pt-4 text-center xl:w-5/6">
        {ctas && ctas.length > 0 && (
          <div className="flex flex-col gap-4 md:flex-row xl:gap-8">
            {ctas.map((cta, index) => {
              return (
                <div
                  key={index}
                  className="flex flex-col items-center justify-center"
                >
                  <h4 className="text-deco-head-6 text-pretty font-rebrand">
                    <em>{cta.heading}</em>
                  </h4>
                  <div className="text-body-3 mt-3 text-pretty">
                    {cta.subtitle}
                  </div>
                  <Link
                    href={cta.link ?? "#"}
                    className="text-body-3 mt-8 rounded-full bg-teal px-8 py-3 font-semibold text-white"
                  >
                    Learn more
                  </Link>
                </div>
              );
            })}
          </div>
        )}
      </div>
    </Block>
  );
}

export default CompanyOverview;
